import { FC, useCallback, useState } from 'react';

import DebuggerWindow from '../DebuggerWindow';
import { GraphQLQuery } from '../../types';

import styles from './Debugger.module.css';

type Props = {
  data: GraphQLQuery[];
};

const Debugger: FC<Props> = ({ data }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <div className={styles.root}>
      {open ? (
        <DebuggerWindow data={data} onClose={handleClose} />
      ) : (
        <button onClick={handleOpen} className={styles.openBtn}>
          Debug
        </button>
      )}
    </div>
  );
};

export default Debugger;
